import BaseSearchDropdown from './BaseSearchDropdown';
import moment from 'moment-timezone';

export default class EncountersDropdown extends BaseSearchDropdown {
    constructor(props) {
        super(props);

        this.formatter = ({datetime}) => moment(datetime).format('MM/DD/YYYY hh:mm a');
    }
}



// WEBPACK FOOTER //
// ./src/components/controls/EncountersDropdown.jsx